import Header from "../../header"
import jordanIntro from "url:../../../asset/jordan_intro.png"
import launchpadPhone from "url:../../../asset/bento/launchpad-phone.png"
import worshipSongsPreview from "url:../../../asset/bento/worship-songs.png"
import eventCards from "url:../../../asset/bento/event-cards.png"

import planningCenter from "url:../../../asset/bento/planning-center.png"
import smartwaiver from "url:../../../asset/bento/smartwaiver.png"

import launchpadTag from "url:../../../asset/bento/launchpadtag.png"
import LaunchpadSection from "./LaunchpadSection"
import LaunchpadTagsSection from "./LaunchpadTagsSection"

// Hidden for now; the mission card sits in its place
const SHOW_BENTO = false

export default function Home() {
  return <div>
    <Header />

    {/* Full screen main */}
    <div className="w-full h-[60vh] flex items-center justify-center p-8 mb-32">
      <div className="text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4 md:mb-6">👋 Meet <span className="text-accent">Salt</span></h1>
        <p className="text-2xl md:text-4xl mb-8">
          <span className="text-accent font-bold">Delightful Tools</span> for your church.
        </p>
      </div>
    </div>

    {SHOW_BENTO && <BentoSection />}

    <MissionCard />

    <LaunchpadSection />

    <LaunchpadTagsSection />

    <GetStartedCard />
  </div>
}

function BentoSection() {
  return <div className="bg-[#F8F8F8] p-16">
    <div>
      <p className="font-semibold text-xl md:text-2xl">Delightful Tools for the Church.</p>
      <h1 className="font-semibold text-3xl md:text-[42px] text-accent">Here's just a few.</h1>

      <div id="bento-cards" className="flex flex-col md:flex-row gap-4 font-semibold text-xl mt-16 md:max-h-100 overflow-hidden">
        <div className="bg-white rounded-4xl text-center flex flex-col flex-1/3 pt-12 min-h-10">
          <h1 className="mb-8">Launchpad</h1>

          <img src={launchpadPhone} className="mx-auto w-9/12 mt-auto" draggable={false} />
        </div>

        <div className="bg-white rounded-4xl text-center flex-1/2 overflow-clip pt-12">
          <h1 className="mb-8">Host Events</h1>

          <img src={eventCards} className="w-full mb-8" draggable={false} />
        </div>

        <div className="bg-white rounded-4xl text-center flex-1/3 pb-12">
          <img src={worshipSongsPreview} className="mx-auto w-2/3" draggable={false} />

          <h1 className="mt-12">Share Worship Songs</h1>
        </div>
      </div>

      <div id="bento-cards-row-2" className="flex flex-col md:flex-row gap-4 font-semibold text-xl mt-4">
        <div className="bg-white rounded-4xl text-center flex flex-col flex-1/3 pt-12 pb-8">
          <h1 className="mb-8">Integrations</h1>

          <img src={planningCenter} className="mx-auto w-1/3 mb-4" draggable={false} />
          <img src={smartwaiver} className="mx-auto w-1/3 mb-4" draggable={false} />
        </div>

        <div className="bg-white rounded-4xl text-center flex-1/3 flex flex-row align-middle items-center justify-center px-12">
          <h1 className="mr-8">Launchpad Tags</h1>

          <img src={launchpadTag} className="h-48 my-4 drop-shadow-[0_4px_8px_rgba(0,0,0,0.2)] rounded-full" draggable={false} />
        </div>
      </div>
    </div>
  </div>
}

function GetStartedCard() {
  return <div className="py-16 px-8 max-w-[718px] mx-auto flex flex-col items-center gap-6">
    <h1 className="self-start text-accent font-semibold text-3xl md:text-[42px]">Get Started</h1>
    <p className="font-semibold text-xl md:text-2xl leading-[1.2] text-[#888888]">
      We'd love to partner with you as we work towards our vision of building Delightful Tools that help churches connect with their members and communities.
      <br />
      <br />
      As we continue to build, we're partnering with a few churches in order to best support them in this early period.
      <br />
      <br />
      If you'd like to use Salt, please Connect with Us and our team will reach out!
    </p>

    <a href={"mailto:jordan@saltplatform.com"} target="_blank" rel="noopener noreferrer" className={`mt-6 py-3 px-6 bg-accent text-white text-lg md:text-xl rounded-full font-medium hover:cursor-pointer hover:opacity-75 transition-opacity duration-300`}>
      Connect with Us
    </a>
  </div>
}

// Mission Card (Figma 566:4690)
function MissionCard() {
  return <div className="px-4 md:px-8 mb-16">
    <div className="max-w-[980px] md:min-h-[705px] mx-auto rounded-[32px] md:rounded-[50px] bg-linear-to-b from-[#fdb9b9] to-[#ffa8a8] text-white px-8 py-10 md:px-[57px] md:pt-[50px] md:pb-[62px]">
      <div className="max-w-[541px] font-semibold text-[22px] md:text-[28px] leading-[1.2] text-shadow-[0px_0px_16.3px_rgba(0,0,0,0.1)] space-y-[1.2em]">
        <p>Church shouldn’t be limited to just your Sunday service.</p>
        <p>We create Delightful Tools that bring your church to everyone, seven days a week.</p>
        <p>Salt also saves your church time, enhances programs, helps you train volunteers, and more.</p>
        <p>So you can focus more on what really matters- your people- instead of technology or busywork.</p>
      </div>

      <img src={jordanIntro} alt="Jordan Osterberg" className="size-[65px] rounded-full mt-8 md:mt-7 md:ml-1" />

      <p className="mt-[22px] md:ml-1 font-semibold text-[17px] leading-[1.2] text-[#f2f2f2]">
        - Jordan Osterberg
        <br />
        Founder of Salt
      </p>
    </div>
  </div>
}
